//记得在 src\components\lang\zhLoad.js 里面添加对象
const unloadOrder = {
  plantCode:'基地编码',
  plantName: '基地名称',
  createTime: '创建时间',
  queueNo:'排队编码',

  msg: {
  }
};
export default unloadOrder



// WEBPACK FOOTER //
// ./src/page/bd/accessory/unloadOrder/lang/unloadOrder.en.js